// ============================================================================
// NEKASSUR — Configuration unique (données validées + drapeaux d'affichage).
// Ne jamais afficher publiquement les valeurs vides ou "[À FOURNIR]".
// ============================================================================

export const site = {
  brand: "NEKASSUR",
  legalName: "NEK ASSUR",
  founder: "Yanis Nekhla",

  phone: "+33 7 77 31 46 23",
  phoneE164: "+33777314623",
  whatsappNumber: "33777314623",
  contactEmail: "nekassur@gmail.com",
  privacyEmail: "nekassur@gmail.com",
  complaintEmail: "nekassur@gmail.com",

  address: "4 place de la Victoire, 54520 Laxou, France",
  city: "Laxou",
  region: "Grand Est",
  openingHours: "9h–19h, sur rendez-vous",
  openingHoursEn: "9am–7pm, by appointment",

  calendlyUrl: "", // [À FOURNIR] — tant que vide : "Prendre rendez-vous" ouvre le formulaire de contact.
  domain: "nekassur.fr",

  // Drapeaux d'affichage
  flags: {
    showFounderPhoto: false,
    showPartnerNames: false,
    showPartnerLogos: false,
    reviewsEnabled: false,
    newsletterEnabled: true,
  },

  partnerNetwork: {
    count: "30+",
    text: "Plus de 30 partenariats actifs couvrant de nombreuses branches et sous-branches de l'assurance.",
    textShort: "Plus de 30 partenariats actifs",
    textEn: "More than 30 active partnerships covering many branches and sub-branches of insurance.",
    textShortEn: "30+ active partnerships",
  },

  social: { linkedin: "", instagram: "", facebook: "", tiktok: "" },

  media: {
    logoUrl: "/brand/nekassur-logo-officiel.png",
    founderPhotoUrl: "", // aucune photo réelle — ne pas afficher de portrait de substitution
    heroImage: "https://static.prod-images.emergentagent.com/jobs/37de4526-6589-4c7c-a903-ffc6baf5ab34/images/19d7ac6a33b42000e82918a052fde27a1329ac13d83a60e52883cad4d56934bd.jpeg",
  },

  legal: {
    legalName: "NEK ASSUR",
    legalForm: "SARL",
    shareCapital: "1 000 €",
    legalCreationDate: "5 février 2026",
    creationDate: "Avril 2026",
    siren: "101 488 757",
    siret: "101 488 757 00010",
    rcs: "101 488 757 R.C.S. Nancy",
    oriasNumber: "26 009 405",
    oriasUrl: "https://www.orias.fr/",
    oriasCategory: "", // [À FOURNIR]
    professionalAssociation: "ENDYA",
    rcpInsurer: "+Simple",
    rcpPolicyNumber: "", // [À FOURNIR si publication requise]
    financialGuaranteeProvider: "+Simple",
    financialGuaranteeDetails: "", // [À FOURNIR si requis]
    supervisoryAuthority: "ACPR — Autorité de contrôle prudentiel et de résolution",
    mediatorName: "La Médiation de l'Assurance",
    mediatorAddress: "TSA 50110 — 75441 Paris Cedex 09",
    mediatorEmail: "le.mediateur@mediation-assurance.org",
    mediatorUrl: "https://www.mediation-assurance.org/",
    publicationDirector: "Yanis Nekhla",
    host: "Infomaniak Network SA, Rue Eugène-Marziano 25, 1227 Les Acacias (GE), Suisse",
  },
};

export const isMissing = (v) => !v || String(v).trim() === "";

export const whatsappLink = (message = "") => {
  if (!site.whatsappNumber) return "";
  const base = `https://wa.me/${site.whatsappNumber}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
};
